import Logan from "logan-web"

export function loganLog(msg, type = 1) {
  console.error(msg)
  Logan.log(msg, type)
}
